import { useTheme } from '@emotion/react';

import Svg from '../svg/Svg';

import { GraphicProps } from './type';

const GraphicHeadphones = ({ isAct = false, ...rest }: GraphicProps) => {
  const theme = useTheme();

  return (
    <Svg {...rest}>
      <g clipPath="url(#clip0_2019_51091)">
        <path
          d="M12.8195 4.06861C8.73421 4.06861 5.94434 6.12625 5.06007 7.15508L4.69531 6.60184L8.50872 3.02037L13.7149 2.20508L18.7883 4.06861L20.6453 7.15508C19.7389 6.12625 16.9049 4.06861 12.8195 4.06861Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M2.67019 15.0531C2.26122 14.4132 2.47474 13.6084 3.1471 13.2554C3.81946 12.9024 4.69605 13.1349 5.10501 13.7748L9.54802 20.7262C9.95699 21.3661 9.74346 22.1709 9.07111 22.5239C8.39875 22.8769 7.52216 22.6444 7.11319 22.0045L2.67019 15.0531Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M23.1892 15.0531C23.5982 14.4132 23.3846 13.6084 22.7123 13.2554C22.0399 12.9024 21.1633 13.1349 20.7544 13.7748L16.3114 20.7262C15.9024 21.3661 16.1159 22.1709 16.7883 22.5239C17.4606 22.8769 18.3372 22.6444 18.7462 22.0045L23.1892 15.0531Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M2.78125 11.8949C2.78125 11.6671 2.96593 11.4824 3.19375 11.4824C3.42157 11.4824 3.60625 11.6671 3.60625 11.8949V13.2699C3.60625 13.4977 3.42157 13.6824 3.19375 13.6824C2.96593 13.6824 2.78125 13.4977 2.78125 13.2699V11.8949Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M23.0781 11.8949C23.0781 11.6671 22.8934 11.4824 22.6656 11.4824C22.4378 11.4824 22.2531 11.6671 22.2531 11.8949V13.2699C22.2531 13.4977 22.4378 13.6824 22.6656 13.6824C22.8934 13.6824 23.0781 13.4977 23.0781 13.2699V11.8949Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M5.09988 13.7562C4.69091 13.1164 4.90443 12.3115 5.57679 11.9585C6.24915 11.6055 7.12574 11.838 7.5347 12.4779L11.9777 19.4293C12.3867 20.0692 12.1732 20.8741 11.5008 21.2271C10.8284 21.5801 9.95185 21.3475 9.54288 20.7076L5.09988 13.7562Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M20.7595 13.7758C21.1685 13.1359 20.9549 12.331 20.2826 11.978C19.6102 11.625 18.7336 11.8576 18.3247 12.4974L13.8817 19.4488C13.4727 20.0887 13.6862 20.8936 14.3586 21.2466C15.0309 21.5996 15.9075 21.367 16.3165 20.7272L20.7595 13.7758Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
        <path
          d="M2.47656 11.3184H4.12656L-nan -nanL4.12656 11.3184C4.12656 11.6221 3.88032 11.8684 3.57656 11.8684H3.02656C2.72281 11.8684 2.47656 11.6221 2.47656 11.3184L-nan -nanL2.47656 11.3184Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M23.3828 11.3184H21.7328L-nan -nanL21.7328 11.3184C21.7328 11.6221 21.9791 11.8684 22.2828 11.8684H22.8328C23.1366 11.8684 23.3828 11.6221 23.3828 11.3184L-nan -nanL23.3828 11.3184Z"
          fill={isAct ? theme.colors.primary : theme.colors.gray3}
        />
        <path
          d="M12.7285 2.79797C6.16592 2.79797 4.31708 8.45504 4.12656 11.3178H2.47656C2.5438 8.17864 5.56749 1.96875 12.7285 1.96875C20.7973 1.96875 23.1994 8.17956 23.3787 11.3187H21.733C21.733 10.2822 20.9318 2.79797 12.7285 2.79797Z"
          fill={isAct ? theme.colors.secondary : theme.colors.gray2}
        />
      </g>
      <defs>
        <clipPath id="clip0_2019_51091">
          <rect width="22" height="21.1945" fill="white" transform="translate(1.92969 1.96875)" />
        </clipPath>
      </defs>
    </Svg>
  );
};

export default GraphicHeadphones;
